module.exports = __webpack_public_path__ + "img/HZ3606-193.69157054.jpg";